module.exports = __webpack_public_path__ + "static/img/offline.9380f08a.png";